var _circle, _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFooterIcon22(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 63,
    viewBox: "0 0 63 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 31.5,
    cy: 31.5,
    r: 31.5,
    fill: "url(#paint0_linear_402_1571)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.6418 14.7214C20.6418 14.9566 20.7525 16.2919 20.8148 16.8661L20.8563 17.1982H17.4248H14.0001V17.3504C13.9932 17.4403 14.2492 20.7058 14.5674 24.6148L15.1348 31.7269H18.5732H22.0048L22.0532 32.225C22.0809 32.5018 22.1224 32.7508 22.1501 32.7785C22.1777 32.8062 24.1841 33.9962 26.6124 35.4214L31.0195 38.0089L35.4265 35.4214C37.848 33.9962 39.8543 32.8131 39.8889 32.7785C39.9166 32.7508 39.9581 32.5018 39.9858 32.225L40.0342 31.7269H43.4658H46.9042L47.4715 24.6148C47.7898 20.7058 48.0458 17.4403 48.0389 17.3504V17.1982H44.6142H41.1827L41.2242 16.8661C41.2865 16.2919 41.3972 14.9566 41.3972 14.7214V14.5H31.0195H20.6418V14.7214ZM21.0154 19.5643C21.0569 19.7857 21.818 29.2501 21.818 29.4715C21.818 29.5684 21.5897 29.5822 19.4657 29.5822C18.172 29.5822 17.1134 29.5614 17.1134 29.5268C17.1134 29.4231 16.3593 20.0555 16.3178 19.7027L16.2832 19.3429H18.6286H20.9808L21.0154 19.5643ZM45.7212 19.6681C45.6866 19.9517 44.9256 29.4162 44.9256 29.5407C44.9256 29.5614 43.867 29.5822 42.5733 29.5822C40.7399 29.5822 40.221 29.5614 40.221 29.4923C40.221 29.3055 40.989 19.7788 41.0236 19.5643L41.0581 19.3429H43.4104H45.7627L45.7212 19.6681Z",
    fill: "url(#paint1_linear_402_1571)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.076 41.5511V45.0795H31.0195H34.963V41.5511V38.0158L34.8108 38.0988C34.7209 38.1473 33.8353 38.6592 32.839 39.2473L31.0264 40.3196L29.2069 39.2473C28.2037 38.6592 27.3181 38.1473 27.2351 38.0988L27.076 38.0158V41.5511Z",
    fill: "url(#paint2_linear_402_1571)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7658 48.4488C22.5444 49.2029 22.3714 49.8394 22.3714 49.8671C22.3714 49.9362 39.6675 49.9362 39.6675 49.8671C39.6675 49.8394 39.4946 49.2029 39.2732 48.4488L38.8788 47.0858H31.0195H23.1601L22.7658 48.4488Z",
    fill: "url(#paint3_linear_402_1571)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_402_1571",
    x1: 31.5,
    y1: 0,
    x2: 31.5,
    y2: 63,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#55C3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4190F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_402_1571",
    x1: 31.0195,
    y1: 38.0089,
    x2: 31.0195,
    y2: 14.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7F1F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_402_1571",
    x1: 31.0195,
    y1: 45.0795,
    x2: 31.0195,
    y2: 38.0158,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7F1F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_402_1571",
    x1: 31.0195,
    y1: 49.9189,
    x2: 31.0195,
    y2: 47.0858,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7F1F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterIcon22);
export default __webpack_public_path__ + "static/media/footer_icon_2_2.e310aa9a7003d6f45b7eb08f19e709a8.svg";
export { ForwardRef as ReactComponent };